import { useQuery, UseQueryResult } from 'react-query'

import { useFeatureFlagsService } from 'features/project/service/feature-flags-service'
import { useProjectStore } from 'features/project/store'
import { ProjectState } from 'types/project'

export const useFeatureFlags = (): UseQueryResult => {
  const projectId = useProjectStore((state: ProjectState) => state.projectId)
  const featureFlagsService = useFeatureFlagsService()

  return useQuery(
    ['feature-flags', projectId],
    () => {
      return featureFlagsService.getFeatureFlags(projectId)
    },
    {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: !!projectId,
    },
  )
}
